import {
  ApolloGlobalManagement,
  Fortress,
  LogoLetters,
  Mio,
  OceanRoad,
  PolarAssetManagement,
  SkyeGlobalManagement,
  Sora,
  Triata,
} from 'assets/icons';
import { colors } from 'theme';

type BrandingConfig = {
  primaryColor: string;
  logo: React.ReactElement;
};

const FORTRESS_ID = '0997eda8-1ed6-4181-afa7-16f3b99cd5d7';
const MIO_ID = 'b180a98f-794f-4752-8fa1-63aa93552e3b';
const SORA_ID = 'd4127f1f-f807-4c85-af4b-bd4a02adca87';
const APOLLO_ID = '259064a3-1525-4cf6-8957-51b16a418a48';
const POLAR_ID = '6396d0dd-c32d-448c-ab36-d318c5a7c797';
const SKYE_ID = '32fd20aa-c8ef-49d9-b495-320e9c21d16a';
const TRIATA_ID = '996fa39b-798d-4090-b6f5-2b406e166098';
const OCEAN_ROAD_ID = '415e2f0f-5199-4b3f-ab64-24a03aa98409';

/**
 * Expandable mapper for specific clients configuration
 */
export const CLIENT_ID_TO_BRANDING_MAPPER: Record<string, BrandingConfig> = {
  [FORTRESS_ID]: {
    primaryColor: colors.primaryFortress,
    logo: <Fortress height={33} width={131} />,
  },
  [MIO_ID]: {
    primaryColor: colors.primaryMio,
    logo: <Mio />,
  },
  [SORA_ID]: {
    primaryColor: colors.primarySora,
    logo: <Sora height={36} width={76} />,
  },
  [APOLLO_ID]: {
    primaryColor: colors.primary,
    logo: <ApolloGlobalManagement height={33} width={131} />,
  },
  [POLAR_ID]: {
    primaryColor: colors.primary,
    logo: <PolarAssetManagement height={33} width={131} />,
  },
  [SKYE_ID]: {
    primaryColor: colors.primary,
    logo: <SkyeGlobalManagement height={33} width={131} />,
  },
  [TRIATA_ID]: {
    primaryColor: colors.primaryTriata,
    logo: <Triata height={33} width={131} />,
  },
  [OCEAN_ROAD_ID]: {
    primaryColor: colors.primaryOceanRoard,
    logo: <OceanRoad />,
  },
  default: {
    primaryColor: colors.primary,
    logo: <LogoLetters />,
  },
};
